/*
  Click-to-play videos with sound on the UNA page: "See it, unedited" (.una-unedited) and the
  "Three ways in" cards (.una-ways-in). Each player is a [data-una-player] box holding a <video>
  and a [data-una-play] button. The videos have sound, so they never autoplay: only the poster
  loads until the visitor clicks the play button (Enter and Space work, as it is a <button>). Then
  the 720 file is used under 750 px wide or with data saver on, else the 1080 file, the native
  controls appear and it plays with sound. A video pauses when scrolled fully out of view and does
  not restart on scroll-in. Starting one video pauses every other one on the page.

  Both sections load this file, so it runs once per page.
*/
(function () {
  if (window.unaPlayers) return;
  window.unaPlayers = true;

  function setup(box) {
    if (box.dataset.unaPlayerReady) return;
    var video = box.querySelector('video');
    var button = box.querySelector('[data-una-play]');
    if (!video || !button) return;
    box.dataset.unaPlayerReady = 'true';

    function pickSource() {
      var connection = navigator.connection;
      var small = window.innerWidth < 750 || (connection && connection.saveData);
      var desktop = video.dataset.src;
      var mobile = video.dataset.srcMobile;
      return (small ? mobile || desktop : desktop || mobile) || '';
    }

    function start() {
      if (!video.getAttribute('src')) {
        var src = pickSource();
        if (!src) return;
        video.src = src;
      }
      video.controls = true;
      box.classList.add('is-started');
      button.hidden = true;
      video.focus();
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    }

    button.addEventListener('click', start);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && !video.paused) video.pause();
        });
      }).observe(video);
    }
  }

  function init(root) {
    root.querySelectorAll('[data-una-player]').forEach(setup);
  }

  // 'play' does not bubble, so listen in the capture phase.
  document.addEventListener(
    'play',
    function (event) {
      var playing = event.target;
      if (!playing.closest || !playing.closest('[data-una-player]')) return;
      document.querySelectorAll('[data-una-player] video').forEach(function (video) {
        if (video !== playing && !video.paused) video.pause();
      });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
